<template>
    <div class="news-list">
        <head-top @navClick="navClickID" :navActive="navActive"></head-top>
        <!-- 内容 start -->
        <div class="news-list-box">
            <div class="news-list-main">
                <list-left @navClick="navClickID"></list-left>
                <div class="news-list-main-right">
                    <div class="report-download-title">
                        <i></i>
                        <p>{{title}}</p>
                    </div>
                    <ul class="new-list-ul">
                        <li @click="DetailClick(item.id,title)" v-for="(item,index) in newsList" :key="index">
                            <i class="icon"></i>
                            <p class="txt">{{item.title}}</p>
                            <span class="data">{{item.created_date}}</span>
                        </li>
                    </ul>
                    <ul class="pagination">
                        <el-pagination
                                @current-change="handleCurrentChange"
                                :current-page.sync="pageCurrent"
                                :page-size="pageSize"
                                background
                                layout="prev, pager, next"
                                :total="total">
                        </el-pagination>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 内容 end -->
        <foot-bottom></foot-bottom>
    </div>
</template>

<script>
    import headTop from '../components/header/head-top'
    import footBottom from '../components/footer/foot-bottom'
    import listLeft from '../components/news-list-left/new-list-left'
    import tool from '@/assets/js/tool.js'
    export default {
        name: "news-list",
        data() {
            return {
                navActive: 4,
                pageSize: 22,
                pageCurrent: 1, //当前页
                total:0, //数据总条数
                title:'',
                currentID:'',
                newsList:{},
                newsCenter:[],
                recList:[],
            }
        },
        components: {
            headTop,
            listLeft,
            footBottom,
        },
        mounted() {
            this.getData();
        },
        methods: {
            navClickID(val){
                if(val){
                    this.listFn(1,val);
                }else{
                    this.listFn(1);
                }
            },
            getData() {
                if(this.$route.query.id){
                    this.listFn(1,this.$route.query.id);
                }else{
                    this.listFn(1);
                }
            },
            DetailClick(ID,title){
                // this.$router.push('/newsListDetail?Nid='+ID);
              this.$router.push({
               path: '/newsListDetail?Nid='+ID,
                query: {
                 title:title
                },
              })
            },
            handleCurrentChange(val){
                this.listFn(val,this.currentID);
            },
            listFn(page,Id){
                this.currentID=Id;
                let data={
                    information_category_id:Id,
                    page:page,
                    page_size:22,
                };
                if(Id){
                    tool.postData('get_info_list',data,(res) => {
                        let category = res.data.data.category_two;
                        for(let i=0;i<category.length;i++){
                            if(category[i]['id']==Id){
                                this.title = category[i]['name'];
                            }
                        }
                        this.total=res.data.data.info_list.total;
                        this.newsList = res.data.data.info_list.data||[];
                    });
                }else{
                    tool.postData('get_info_list',data,(res) => {
                        this.title = res.data.data.category_two[0]['name'];
                        this.total=res.data.data.info_list.total;
                        this.newsList = res.data.data.info_list.data||[];
                    });
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/style/common";

    .news-list {
        width: 100%;
        height: 100%;
        background-color: #eff4ff;
    }

    .news-list-box {
        width: 100%;
        background: url("../../static/img/nav.png") no-repeat top center;
        padding-top: 80px;
        box-sizing: border-box;
        margin-bottom: 60px;
        .news-list-main {
            width: $box-width;
            @include flex($align: flex-start);
            margin: 0 auto;
            .news-list-main-right {
                width: 892px;
                height: 1484px;
                background-color: #fff;
                padding: 0 26px;
                box-sizing: border-box;
                .report-download-title {
                    width: 100%;
                    height: 94px;
                    display: flex;
                    align-items: center;
                    i {
                        width: 10px;
                        height: 10px;
                        background-color: #3b6bda;
                        margin-right: 10px;
                    }
                    p {
                        @include font(25px, #333);
                        margin-right: 20px;
                        font-weight: bold;
                    }
                    span {
                        @include font(20px, #666)
                    }
                }
                .new-list-ul {
                    border-bottom: 1px solid #c4d2f4;
                    li {
                        margin-bottom: 35px;
                        display: flex;
                        align-items: center;
                        .icon {
                            width: 5px;
                            height: 5px;
                            background-color: #3b6bda;
                            border-radius: 50%;
                            margin-right: 13px;
                        }
                        .txt {
                            @include font(18px, #666);
                            width: 680px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                        .data {
                            @include font(18px, #666);
                            text-align: right;
                            margin-left: 40px;
                        }
                        &:hover{cursor: pointer;}
                    }
                }
            }
        }
    }

    .pagination {
        text-align: center;
        margin-top: 50px;
    }
    .el-icon-arrow-right {
      -webkit-transform: rotate(90deg);
      transform: rotate(90deg);
    }
</style>



// WEBPACK FOOTER //
// src/pages/news-list.vue